module.exports = "tr.td-data-table-row {\n  height: 80px; }\n\n.color_1 {\n  color: red; }\n\n.color_2 {\n  color: #32c832; }\n\n.color_3 {\n  color: #e87214; }\n\n.HandCursor {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/consulta/modanamnesis/cerrados/cerrados.component.scss
// module id = ./src/app/consulta/modanamnesis/cerrados/cerrados.component.scss
// module chunks = main